import { BottomOrRegularModal } from '@popsure/dirty-swan';
import Markdown from 'components/markdown';
import { useState } from 'react';

export type ModalProps = {
  label: string;
  title: string;
  body: string; // markdown
};

export const Modal = ({ label, title, body }: ModalProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <button
        className="p-a mt16 fw-bold c-pointer bg-transparent"
        type="button"
        onClick={() => setModalOpen(true)}
      >
        {label}
      </button>
      <BottomOrRegularModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title={title}
      >
        <div className="pt16 px24 pb24">
          <Markdown className="p-p wmx6">{body}</Markdown>
        </div>
      </BottomOrRegularModal>
    </>
  );
};
